import React, { useState, useEffect, useRef } from 'react';

const CountryCodeSelector = ({ selectedCode, onCodeSelect, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const dropdownRef = useRef(null);

  // Cerrar dropdown cuando se hace click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setHoveredIndex(-1);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const countries = [
    { code: '+62', country: 'ID', name: 'Indonesia', flag: '🇮🇩' },
    { code: '+34', country: 'ES', name: 'España', flag: '🇪🇸' },
    { code: '+1', country: 'US', name: 'Estados Unidos', flag: '🇺🇸' },
    { code: '+1', country: 'CA', name: 'Canadá', flag: '🇨🇦' },
    { code: '+44', country: 'GB', name: 'Reino Unido', flag: '🇬🇧' },
    { code: '+33', country: 'FR', name: 'Francia', flag: '🇫🇷' },
    { code: '+49', country: 'DE', name: 'Alemania', flag: '🇩🇪' },
    { code: '+39', country: 'IT', name: 'Italia', flag: '🇮🇹' },
    { code: '+55', country: 'BR', name: 'Brasil', flag: '🇧🇷' },
    { code: '+52', country: 'MX', name: 'México', flag: '🇲🇽' },
    { code: '+54', country: 'AR', name: 'Argentina', flag: '🇦🇷' },
    { code: '+57', country: 'CO', name: 'Colombia', flag: '🇨🇴' },
    { code: '+51', country: 'PE', name: 'Perú', flag: '🇵🇪' },
    { code: '+56', country: 'CL', name: 'Chile', flag: '🇨🇱' },
    { code: '+58', country: 'VE', name: 'Venezuela', flag: '🇻🇪' },
    { code: '+598', country: 'UY', name: 'Uruguay', flag: '🇺🇾' },
    { code: '+595', country: 'PY', name: 'Paraguay', flag: '🇵🇾' },
    { code: '+593', country: 'EC', name: 'Ecuador', flag: '🇪🇨' },
    { code: '+591', country: 'BO', name: 'Bolivia', flag: '🇧🇴' },
    { code: '+60', country: 'MY', name: 'Malasia', flag: '🇲🇾' },
    { code: '+65', country: 'SG', name: 'Singapur', flag: '🇸🇬' },
    { code: '+66', country: 'TH', name: 'Tailandia', flag: '🇹🇭' },
    { code: '+84', country: 'VN', name: 'Vietnam', flag: '🇻🇳' },
    { code: '+63', country: 'PH', name: 'Filipinas', flag: '🇵🇭' },
    { code: '+81', country: 'JP', name: 'Japón', flag: '🇯🇵' },
    { code: '+82', country: 'KR', name: 'Corea del Sur', flag: '🇰🇷' },
    { code: '+86', country: 'CN', name: 'China', flag: '🇨🇳' },
    { code: '+91', country: 'IN', name: 'India', flag: '🇮🇳' },
    { code: '+7', country: 'RU', name: 'Rusia', flag: '🇷🇺' },
    { code: '+380', country: 'UA', name: 'Ucrania', flag: '🇺🇦' },
    { code: '+48', country: 'PL', name: 'Polonia', flag: '🇵🇱' },
    { code: '+31', country: 'NL', name: 'Países Bajos', flag: '🇳🇱' },
    { code: '+46', country: 'SE', name: 'Suecia', flag: '🇸🇪' },
    { code: '+47', country: 'NO', name: 'Noruega', flag: '🇳🇴' },
    { code: '+45', country: 'DK', name: 'Dinamarca', flag: '🇩🇰' },
    { code: '+41', country: 'CH', name: 'Suiza', flag: '🇨🇭' },
    { code: '+43', country: 'AT', name: 'Austria', flag: '🇦🇹' },
    { code: '+32', country: 'BE', name: 'Bélgica', flag: '🇧🇪' },
    { code: '+351', country: 'PT', name: 'Portugal', flag: '🇵🇹' },
    { code: '+30', country: 'GR', name: 'Grecia', flag: '🇬🇷' },
    { code: '+90', country: 'TR', name: 'Turquía', flag: '🇹🇷' },
    { code: '+972', country: 'IL', name: 'Israel', flag: '🇮🇱' },
    { code: '+971', country: 'AE', name: 'Emiratos Árabes', flag: '🇦🇪' },
    { code: '+966', country: 'SA', name: 'Arabia Saudí', flag: '🇸🇦' },
    { code: '+20', country: 'EG', name: 'Egipto', flag: '🇪🇬' },
    { code: '+27', country: 'ZA', name: 'Sudáfrica', flag: '🇿🇦' },
    { code: '+234', country: 'NG', name: 'Nigeria', flag: '🇳🇬' },
    { code: '+61', country: 'AU', name: 'Australia', flag: '🇦🇺' },
    { code: '+64', country: 'NZ', name: 'Nueva Zelanda', flag: '🇳🇿' }
  ];

  const selectedCountry = countries.find(country => country.code === selectedCode) || countries[0];

  const dropdownStyle = {
    position: 'relative',
    display: 'inline-block'
  };

  const buttonStyle = {
    padding: '10px 12px',
    border: '2px solid #ddd',
    borderRight: 'none',
    borderRadius: '5px 0 0 5px',
    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    minWidth: '95px',
    height: '40px',
    opacity: disabled ? 0.6 : 1,
    transition: 'all 0.2s ease',
    fontWeight: '500',
    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)'
  };

  const listStyle = {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    background: '#ffffff',
    border: '2px solid #ccc',
    borderRadius: '8px',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 1000,
    boxShadow: '0 10px 30px rgba(0,0,0,0.2), 0 6px 15px rgba(0,0,0,0.15)',
    marginTop: '2px',
    pointerEvents: 'auto'
  };

  const itemStyle = {
    padding: '12px 15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '14px',
    borderBottom: '1px solid #e5e5e5',
    transition: 'all 0.2s ease',
    userSelect: 'none',
    fontWeight: '500',
    color: '#333'
  };

  return (
    <div ref={dropdownRef} style={dropdownStyle}>
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        style={buttonStyle}
        disabled={disabled}
      >
        <span>{selectedCountry.flag}</span>
        <span style={{ color: '#000', fontWeight: '600' }}>{selectedCountry.code}</span>
        <span style={{ fontSize: '12px', marginLeft: 'auto' }}>▼</span>
      </button>
      
      {isOpen && (
        <div style={listStyle}>
          {countries.map((country, index) => (
            <div
              key={`${country.code}-${country.country}`}
              style={{
                ...itemStyle,
                backgroundColor: hoveredIndex === index ? '#f0f8ff' : 'transparent',
                borderLeft: hoveredIndex === index ? '4px solid #007bff' : '4px solid transparent',
                transform: hoveredIndex === index ? 'translateX(2px)' : 'translateX(0)'
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onCodeSelect(country.code);
                setIsOpen(false);
                setHoveredIndex(-1);
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(-1)}
            >
              <span>{country.flag}</span>
              <span style={{ color: '#000', fontWeight: '600' }}>{country.code}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountryCodeSelector;